// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"588afd38","365":"9fee3938","453":"cafd4525"}[chunkId] + ".chunk.js";
};